import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const printLogs = (logs) => {
  if (!logs || logs.length === 0) {
    alert("No logs available to print.");
    return;
  }

  const tableRows = logs
    .map(
      (log) => `
      <tr>
        <td>${log.userid}</td>
        <td>${log.loggedIn}</td>
        <td>${log.loggedOut}</td>
      </tr>
    `
    )
    .join("");

  const printWindow = window.open("", "", "width=800,height=600");

  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>User Logs</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f4f4f4; }
          </style>
        </head>
        <body>
          <h1>User Logs</h1>
          <table>
            <thead>
              <tr>
                <th>User ID</th>
                <th>Logged In</th>
                <th>Logged Out</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              }
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } else {
    alert("Failed to open print window. Please try again.");
  }
};

export const downloadPDF = (pdfRef) => {
  const input = pdfRef.current;
  html2canvas(input).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4", true);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    const imgX = (pdfWidth - imgWidth * ratio) / 2;
    const imgY = 30;
    pdf.addImage(
      imgData,
      "PNG",
      imgX,
      imgY,
      imgWidth * ratio,
      imgHeight * ratio
    );
    pdf.save("logs.pdf");
  });
};
